import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {Location} from '../../location.models';
import {LocationService} from "../../location.service";

// tslint:disable-next-line:no-empty-interface
export interface DialogData extends Location {
}


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'create-location-dialog',
    templateUrl: 'create-location-dialog.html',
})
// tslint:disable-next-line:component-class-suffix
export class CreateLocationDialog {
    progress = false;
    location: Location;
    acquisitionDate = new FormControl();
    startDate = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<CreateLocationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public locationService: LocationService,
        private _snackBar: MatSnackBar) {
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnInit() {
        if (this.data) {
            this.location = this.data;
            this.acquisitionDate.setValue(this.data.acquiredOn);
            this.startDate.setValue(this.data.startedOn);
        }
    }

    setupDates(): void {
        this.location.acquiredOn = this.acquisitionDate.value;
        this.location.startedOn = this.startDate.value;
    }

    onSubmit(): void {
        this.progress = true;
        this.setupDates();
        this.locationService.create(this.location)
            .subscribe(
                response => {
                    this.progress = false;
                    this.dialogRef.close(response);
                    this._snackBar.open('Location \"' + this.location.name + '\" was successfully created/updated!', 'Close', {
                        duration: 5000,
                    });
                },
                error => {
                    console.log(error);
                });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
